var render, staticRenderFns
import script from "./ybutton.vue?vue&type=script&lang=js&"
export * from "./ybutton.vue?vue&type=script&lang=js&"
import style0 from "./ybutton.vue?vue&type=style&index=0&id=dc10d8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc10d8f6",
  null
  
)

export default component.exports